export default {
  id: 52,
  title: 'Target #52 - Break the Chain',
  url: 'https://cssbattle.dev/play/52',
  colors: ['#6592CF', '#243D83', '#EEB850'],
  solution:
    '<a a><a b><style>body{background:#6592CF}a{position:fixed}a[a]{background:#EEB850;top:120;left:30;width:40;height:40;border-radius:50%;box-shadow:45px -10px 0 10px #EEB850,90px 0 #EEB850}a[b],a[b]:after{position:fixed;background:#243D83;box-shadow:45px 0 #243D83,90px 0 #243D83,165px 0 #243D83,210px 0 #243D83,255px 0 #243D83,300px 0 #243D83}a[b]{top:140;left:45;width:10;height:50}a[b]:after{content:"";top:130;left:40;width:20;height:20;border-radius:50%}</style>',
}
